import { ApolloProvider } from '@apollo/client';
import ErrorFallback from 'src/components/error-fallback/ErrorFallbackDialog';
import 'core-js';
import { ErrorBoundary } from 'react-error-boundary';
import 'regenerator-runtime';
import { CacheBusterProvider } from 'src/components/cache-buster/CacheBusterContext';
import CachePopup from 'src/components/cache-buster/CachePopup';
import { FeatureFlagProvider } from 'src/components/feature-flags/FeatureFlagProvider';
import { ReactNode } from 'react';
import { PermissionsContextProvider } from 'src/components/permissions/PermissionsContext';
import { HelmetProvider } from 'react-helmet-async';
import ThemeProvider from '../theme/ThemeProvider';
import { client } from '../apollo/ApolloClient';
import { AdobeContextProvider } from '../components/adobe/AdobeContext';

// Wraps the app in providers that are used throughout the app
function AppProviders({ children }: { children: ReactNode }) {
  if (!client) {
    return null;
  }

  return (
    <HelmetProvider>
      <ApolloProvider client={client}>
        <CacheBusterProvider>
          <ErrorBoundary onReset={() => window.location.reload()} FallbackComponent={ErrorFallback}>
            <ThemeProvider>
              <FeatureFlagProvider>
                <PermissionsContextProvider>
                  <AdobeContextProvider>
                    {children}
                    <CachePopup />
                  </AdobeContextProvider>
                </PermissionsContextProvider>
              </FeatureFlagProvider>
            </ThemeProvider>
          </ErrorBoundary>
        </CacheBusterProvider>
      </ApolloProvider>
    </HelmetProvider>
  );
}

export default AppProviders;
